import { useTranslation } from 'react-i18next';
import { Button } from '../UI/base/Button';
import DotIndicatorIcon from '../../assets/icons/dot-indicator.svg?react';
import SaveIcon from '../../assets/icons/save.svg?react';
import { useAppSelector } from '../../store/hooks';
import styles from './GanttEditToolbar.module.css';

interface EditActionsProps {
  visible: boolean;
  onDiscard: () => void;
  onAccept: () => void | Promise<void>;
}

export const EditActions = ({ visible, onDiscard, onAccept }: EditActionsProps) => {
  const { t } = useTranslation();
  const hasUnsavedChanges = useAppSelector((state) => state.applicationSlice.hasUnsavedChanges);

  return (
    <div className={`${styles.editActions} ${visible ? styles.editActionsVisible : ''}`}>
      <Button type="tertiary" onClick={onDiscard}>
        {t('edit-plan-discard')}
      </Button>
      <Button
        type="secondary"
        icon={<DotIndicatorIcon />}
        onClick={() => {}}
        styles={{ root: { gap: 4, padding: 8 } }}
      >
        {t('edit-plan-calculate')}
      </Button>
      <Button
        type="primary"
        icon={<SaveIcon />}
        onClick={onAccept}
        disabled={!hasUnsavedChanges}
        styles={{ root: { gap: 4, padding: 12 } }}
      >
        {t('edit-plan-accept')}
      </Button>
    </div>
  );
};
